import React from 'react';

export default function MenuHeader({ children }: { children: React.ReactNode }) {
  return <div className="react-context-menu-header">{children}</div>;
}
